import { Outlet } from 'react-router-dom';

export default function EmailInvoices() {
    return (
        <Outlet />
    )
}
